export default{
    egateeUserCenter: "Egatee 用户中心",
    mayTheForceBeWithU: "May the force be with you",
    egatee: "Egatee",
    jde: "JDE",
    egateeShopCenter: "Egatee 店铺中心",
    egateeGlobalCommandCenter: "Egatee 全球指挥中心",
    egateeCountrySite: "Egatee 国家中心",
    shopCenter: "店铺中心",
    globalCommandCenter: "全球指挥中心",
    countrySite: "国家中心",
    suppliersSettled: "商家结算",
    supplierInformation: "商家信息",
    subjectInformation: "主体信息",
    mmdc:'MMDC',
    mmdc_title:'数据大盘'
}